var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { h } from 'preact';
import classnames from 'classnames';
import style from './style.scss';
var TextArea = function (_a) {
    var _b;
    var label = _a.label, disabled = _a.disabled, props = __rest(_a, ["label", "disabled"]);
    return (h("div", { class: classnames(style['fmc-textarea'], (_b = {}, _b[style.disabled] = disabled, _b)) },
        h("label", { class: style['fmc-textarea-label'] }, label),
        h("textarea", __assign({}, props, { disabled: disabled, class: style['fmc-textarea-field'] }))));
};
export default TextArea;
